import classNames from 'classnames';
import React from 'react';
import { GA_VIEW_MORE_ACTION } from '../../constants/analytics';
import { FeatureFlags } from '../../types/index';
import { SearchEventCard } from '../EventCard';
import { SeeMoreButton } from '../SeeMoreButton';

const getCards = ({
    isSmallCity,
    cards,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    affCode,
}: {
    isSmallCity: boolean;
    cards: any;
    isAuthenticated: boolean;
    onTrackClick: Function;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
}) => {
    const cardsArrayLength = cards.length;
    return cards.map(({ id, ...cardProps }: { id: string }, index: number) => {
        const shouldTrimOddCard =
            cardsArrayLength % 2 === 1 &&
            index === cardsArrayLength - 1 &&
            !isSmallCity;
        const classes = classNames(
            'eds-g-cell',
            'eds-g-cell--has-overflow',
            'eds-g-cell-md-4-12',
            'eds-g-cell-sm-6-12',
            'eds-g-cell-1-1',
            {
                //hide extraneous cards
                'eds-show-up-sm': index > 2 && !isSmallCity,
                //trim odd card so doesnt look wierd on medium breakpoints
                'eds-hide-sm eds-hide-sw eds-hide-mn': shouldTrimOddCard,
            },
        );

        return (
            <div className={classes} key={id}>
                <SearchEventCard
                    id={id}
                    isAuthenticated={isAuthenticated}
                    trackClick={onTrackClick?.bind(null, { id })}
                    trackClickInternal={onTrackClickInternal?.bind(null, index)}
                    trackGAEvent={trackGAEvent}
                    experiments={experiments}
                    featureFlags={featureFlags}
                    affCode={affCode}
                    {...cardProps}
                />
            </div>
        );
    });
};

export const BigEventCardGroup = ({
    cards,
    linkUrl,
    isAuthenticated,
    onTrackClick,
    isSmallCity,
    title,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    affCode,
}: {
    cards: any;
    linkUrl?: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    isSmallCity: boolean;
    title?: string;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
}) => (
    <div className="eds-g-group">
        {getCards({
            isSmallCity,
            cards,
            isAuthenticated,
            onTrackClick,
            onTrackClickInternal,
            trackGAEvent,
            experiments,
            featureFlags,
            affCode,
        })}
        <div className="eds-show-down-sn eds-align--center">
            <div className="eds-g-cell">
                <SeeMoreButton
                    linkUrl={linkUrl || ''}
                    trackClick={onTrackClick}
                    title={title || ''}
                    gaAction={GA_VIEW_MORE_ACTION}
                />
            </div>
        </div>
    </div>
);

export default BigEventCardGroup;
